export default "__VITE_ASSET__Bkg_hHDx__"